<template>
  <li
    class="rec-swiper-item"
    :style="{ backgroundImage }"
    @click="clickFeed()"
  >
    <!-- <div class="logo" :style="{...tagTypeImage}" /> -->
    <img
      :src="tagTypeImage"
      alt="微视logo"
      class="logo"
    >
    <div class="mask">
      <div class="desc">
        {{ feed.feedDescWithat }}
      </div>
      <div class="play-num">
        <i />{{ playNum }}
      </div>
    </div>
    <JumpMiniApp
      v-if="miniAppPathClickRecItem"
      :path="miniAppPathClickRecItem"
      @launch="clickFeed(true)"
    />
  </li>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ModelMetaFeed } from '@/types/model';
import { EMiniAppPosition } from '@/constants/mini-app';
import useGetCommonMethods from '@/composable/use-get-common-method';
import { addNumUint } from '@/utils/number';
import { fixHttps } from '@/utils/no-import-meta/url';
import JumpMiniApp from '@/components/common/jump-mini-app.vue';

const enum EEmitEvent {
  onClickFeed = 'on-click-feed',
}

export default defineComponent({
  components: {
    JumpMiniApp,
  },
  props: {
    feed: {
      type: Object as PropType<ModelMetaFeed>,
      default: () => ({}),
    },
    recommendtags: {
      type: Object,
      default: () => ({}),
    },
    defaultTagImg: {
      type: String,
      default: 'http://qzonestyle.gtimg.cn/qzone/qzactStatics/imgs/20201117211105_00368a.png',
    },
  },
  emits: [EEmitEvent.onClickFeed],
  setup() {
    const { getMiniAppPath } = useGetCommonMethods();
    return {
      getMiniAppPath,
    };
  },
  computed: {
    backgroundImage() {
      return `url(${fixHttps(this.feed?.images?.[0]?.url)})`;
    },
    playNum() {
      return addNumUint(this.feed.playNum, 'cn');
    },
    tagTypeImage() {
      const img = this.recommendtags?.[this?.feed?.feedRecommendReason]?.icon || this.defaultTagImg;
      return img;
    },
    miniAppPathClickRecItem() {
      return this.getMiniAppPath(EMiniAppPosition.recommendVideo, { feedId: this.feed.id, outFrom: 10001 });
    },
  },
  methods: {
    clickFeed(clickMiniApp = false) {
      this.$emit(EEmitEvent.onClickFeed, this.feed, clickMiniApp);
    },
  },
});
</script>

<style lang="scss" scoped>
.rec-swiper-item {
  position: relative;
  width: 49%;
  @include responsiveStyleSingle(height, 81.6, 'vw');
  overflow: hidden;
  @include responsiveStyleSingle(margin-bottom, 1.3333, 'vw');
  @include responsiveStyleSingle(border-radius, 1.3333, 'vw');
  background-size: cover;
  .logo {
    @include responsiveStyleSingle(height, 5, 'vw');
    position: absolute;
    @include responsiveStyleSingle(top, 2.6667, 'vw');
    @include responsiveStyleSingle(right, 2.6667, 'vw');
    // background-image: url('https://sola.gtimg.cn/aoi/sola/20200728161048_ZVL0zEwXdN.png');
    // background-size: 100% 100%;
  }
  .mask {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    @include responsiveStyleSingle(padding-right, 2.1333,'vw');
    @include responsiveStyleSingle(padding-bottom, 2.6667,'vw');
    @include responsiveStyleSingle(padding-left, 2.4,'vw');
    @include responsiveStyleSingle(font-size, 3.7333, 'vw');
    word-break: break-all;
    background-image: linear-gradient(180deg, transparent 41%, rgba(0, 0, 0, 0.6));
    .play-num {
      display: flex;
      align-items: center;
      @include responsiveStyleSingle(margin-top,1.3333, 'vw');
      i {
        display: inline-block;
        @include responsiveStyleSingle(width, 4.2667, 'vw');
        @include responsiveStyleSingle(height, 4.2667, 'vw');
        @include responsiveStyleSingle(margin-right, 0.5333, 'vw');
        background: url('https://sola.gtimg.cn/aoi/sola/20200722113748_OlyNJSgSsR.png');
        background-size: 100% 100%;
      }
    }
  }
}
</style>
